module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Don\u0027t keep asking":"Nicht erneut fragen","Cancel":"Abbrechen","Delete":"Löschen"}}')
  delete Component.options._Ctor
}
